import React, { Component } from 'react';
import './App.css';
import OnlineBooking from './OnlineBooking';

class App extends Component {
    render() {
        return (
            <OnlineBooking />
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js